import deepmerge from '@mui/utils/deepmerge';
function merge(acc, item) {
  if (!item) {
    return acc;
  }
  return deepmerge(acc, item, {
    clone: false // No need to clone deep, it's way faster.
  });
}
export default merge;


//////////////////
// WEBPACK FOOTER
// ../@mui/system/esm/merge.js
// module id = 296
// module chunks = 25